import { motion, useReducedMotion, type Transition } from "framer-motion";
import { cn } from "@/lib/utils";

type BorderBeamProps = {
  className?: string;
  size?: number;
  duration?: number;
  delay?: number;
  colorFrom?: string;
  colorTo?: string;
  reverse?: boolean;
  borderWidth?: number;
  transition?: Transition;
};

export function BorderBeam({
  className,
  size = 90,
  duration = 8,
  delay = 0,
  colorFrom = "hsl(var(--primary))",
  colorTo = "#ffb4a2",
  reverse = false,
  borderWidth = 1.5,
  transition,
}: BorderBeamProps) {
  const reduceMotion = useReducedMotion();

  return (
    <div
      className="pointer-events-none absolute inset-0 rounded-[inherit]"
      style={{
        padding: borderWidth,
        WebkitMask:
          "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        WebkitMaskComposite: "xor",
        mask: "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
        maskComposite: "exclude",
      }}
    >
      <motion.div
        className={cn("absolute aspect-square", className)}
        style={{
          width: size,
          background: `linear-gradient(to left, ${colorFrom}, ${colorTo}, transparent)`,
          offsetPath: `rect(0 auto auto 0 round ${size}px)`,
        }}
        initial={{ offsetDistance: reverse ? "100%" : "0%" }}
        animate={
          reduceMotion
            ? { offsetDistance: reverse ? "100%" : "0%" }
            : { offsetDistance: reverse ? "0%" : "100%" }
        }
        transition={{
          repeat: reduceMotion ? 0 : Infinity,
          ease: "linear",
          duration,
          delay: -delay,
          ...transition,
        }}
      />
    </div>
  );
}
